var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      "default-active-key": _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: "INTERNAL_MAIL",
    attrs: {
      tab: _vm.$t("站内信"),
      "force-render": ""
    }
  }, [_vm.activeKey === "INTERNAL_MAIL" ? _c("mail-collapse-panel", {
    attrs: {
      variables: _vm.variables,
      tabKey: "INTERNAL_MAIL",
      sceneListId: _vm.sceneListId
    }
  }) : _vm._e()], 1), _c("a-tab-pane", {
    key: "NOTE",
    attrs: {
      tab: _vm.$t("短信"),
      "force-render": ""
    }
  }, [_vm.activeKey === "NOTE" ? _c("mail-collapse-panel", {
    attrs: {
      allMessageList: _vm.messageLists,
      variables: _vm.variables,
      tabKey: "NOTE",
      sceneListId: _vm.sceneListId
    }
  }) : _vm._e()], 1), _c("a-tab-pane", {
    key: "EMAIL",
    attrs: {
      tab: _vm.$t("邮件"),
      "force-render": ""
    }
  }, [_vm.activeKey === "EMAIL" ? _c("mail-collapse-panel", {
    attrs: {
      variables: _vm.variables,
      tabKey: "EMAIL",
      sceneListId: _vm.sceneListId
    }
  }) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };